// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { createAsyncAction } from 'typesafe-actions';
import { ProductCard } from '../../../components/NewCard/types';
import { PaginationListResponse, SearchCondition } from '../../../types/Model';

export interface SearchChallengesRequestPayload {
  limit: number;
  page: number;
  condition: SearchCondition;
}

export type SearchChallengesSuccessPayload = PaginationListResponse<ProductCard>;

export interface SearchChallengesFailPayload {
  error: Error;
}

export const searchChallengesActions = createAsyncAction(
  'elearning/SEARCH_CHALLENGES',
  'elearning/SEARCH_CHALLENGES_SUCCESS',
  'elearning/SEARCH_CHALLENGES_FAIL'
)<
  SearchChallengesRequestPayload,
  SearchChallengesSuccessPayload,
  SearchChallengesFailPayload
>();
